// Resume-progress toast shown when a verified visitor returns to a saved draft.
// It's a transient Snackbar (not a fixed banner) so the restored state is
// acknowledged calmly and then gets out of the way. A "Start over" action stays
// available while it's visible, guarded by a confirmation dialog so progress
// isn't lost by accident.
import { useState } from 'react';
import {
  Snackbar, Button, Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions,
} from '@mui/material';

const AUTO_HIDE_MS = 6000;

const ResumeDraftBanner = ({ onStartOver }) => {
  const [open, setOpen] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const confirmStartOver = () => {
    setConfirmOpen(false);
    setOpen(false);
    onStartOver();
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={AUTO_HIDE_MS}
        onClose={(_event, reason) => {
          if (reason !== 'clickaway') setOpen(false);
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message="Welcome back — we restored your progress."
        action={(
          <Button color="inherit" size="small" onClick={() => setConfirmOpen(true)}>
            Start over
          </Button>
        )}
      />

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Start over?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This clears the area and products we restored so you can begin a fresh
            request. This can&apos;t be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Keep my progress</Button>
          <Button color="error" onClick={confirmStartOver}>Start over</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResumeDraftBanner;
